import React, { FC } from 'react';

import { RemoteComponent } from '@adsk/exo-skeleton-react';

type RemoteNetworkBuildersProfileModalProps = {
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  // isBuildersProfileModalEnabled is passed to TopNav, where a conditional button to open the modal is rendered. The prop is set to `undefined` when the prop needs to be re-evaluated (i.e. when a user successfully on-boards)
  isBuildersProfileModalEnabled: boolean | undefined;
  setIsBuildersProfileModalEnabled: (
    isBuildersProfileModalEnabled: boolean | undefined,
  ) => void;
};

const RemoteNetworkBuildersProfileModal: FC<
  RemoteNetworkBuildersProfileModalProps
> = ({ ...props }) => (
  <RemoteComponent
    scope="accNetworkApiComponents"
    moduleName="./BuildersProfileModal"
    {...props}
  />
);

export default RemoteNetworkBuildersProfileModal;
